module.exports = __webpack_public_path__ + "img/teacherWx.7d3af475.png";